export enum CommitteeType {
  Active = 2,
  Closed = 3,
  NotHeld = 4,
  Inactive = 5,
  Unscheduled = 6,
}

export enum StateContentType {
  Default = 1,
  WithLocation = 2,
}

export enum CommitteePurposeType {
  DisabledAppeal = 1, // ערעור על ועדה מחוזית
  Regulation9 = 2, // תקנה 9
  CourtRuling = 3, // פסק דין בית משפט
  KatagAppeal = 4, // ערעור קת"ג
  FirstCommittee = 5, // ועדה מדרג ראשון
  Regulation28A = 6, // ועדה לפי 28א
  ExpiredReturn = 7, // חזרת מצב קודם
  ConditionWorseningReturn = 8, // חזרת מצב מחמיר
  CourtRulingRehearing = 9, // פסק דין בית משפט – דיון חוזר
  Regulation37Katag = 10, // ועדה לפי 37 קת"ג
  AdditionalCommittee = 11, // נוספת
  ExternalEventIntervenes = 12, // אירוע חיצוני
  Other = 9999, // אחר
}

export enum HearingStageType {
  Meeting = 1,
  CommitteeDecisionApproval = 2,
  DisabilityPercentageDetermination = 3,
}

export enum MeetNotHeldReason {
  ApplicantAbsent = 1,
  RequestedByApplicant = 4,
  RequestedByAuthority = 5,
  RequestedByLawyer = 13,
}

export enum PatientAttendanceStatus {
  No = 1,
  Yes = 2,
  WillAttend = 3,
  Canceled = 4,
  Zoom = 5,
  WillNotAttend = 6,
  LawyerOnly = 7,
  Other = 9999,
}

// PendingTaskType removed - replaced by DocumentsMissingType in IUserTask

export enum DocumentsMissingType {
  SpecialistConsultationReferral = 166,
  RequestMedicalDocuments = 169,
  RequestMedicalDocumentsWarning = 170,
  RequestMedicalExamWarning = 172,
  CommitteeMedicalExamReferral = 180,
  ScheduledCommitteeExamReferral = 181,
  ReferralToHMO = 189,
  AppealAdditionalDocumentsRequest = 199,
  XrayReferralIchilov = 203,
  TelHashomerExamReferral = 533,
  GeneralMedicalExamReferral = 534,
  Other = 9999,
}

export enum MeetNotSummarizedReason {
  MissingMedicalDocuments = 2,
  AdditionalDoctor = 7,
  DifferentPanel = 8,
  ReDiscussion = 12,
  CommitteeRequestedPresence = 14,
}

export enum CommitteeUserState {
  Type1 = 1,
  Type2 = 2,
  Type3 = 3,
  Type4 = 4,
  Type5 = 5,
  Type6 = 6,
  Type7 = 7,
  Type8 = 8,
  Type9 = 9,
  Type10 = 10,
}

export enum CommitteeLevel {
  Upper = 1,
  Regional = 2,
}

export interface IUserTask {
  documentType: IEnumInfo<DocumentsMissingType>;
  reqNumber: string;
  isClosed: boolean;
  remarks: string;
  kviatNechutReqNumber?: string;
  documentDescription?: string;
}

export interface ICommitteePgimaDto {
  kviatNechutReqNumber: string;
  pgimaReqNumber: string;
  code?: number;
  name: string;
  detailsCode?: number;
  detailsDescription?: string;
  isDisease?: boolean;
  commitType?: CommitteeLevel;
}

export interface IPreviousMeetInfoDto {
  meetNumber: number;
  meetDate?: Date;
  pgimot: ICommitteePgimaDto[];
  isMeetSummarized: boolean;
  recording?: IRecordingDto;
  protocol?: IProtocolDto;
  notSummarizedReason?: IEnumInfo<MeetNotSummarizedReason>;
}

export interface IEnumInfo<T> {
  id: T;
  name: string;
}

export interface ICommittee {
  meetNumber: number;
  type: IEnumInfo<CommitteeType>;
  lastUpdated?: Date;
  pgimot: ICommitteePgimaDto[];
}

export interface IActiveCommittee extends ICommittee {
  purposeType: IEnumInfo<CommitteePurposeType>;
  stage: IEnumInfo<HearingStageType>;
  isShowAwaitForProtocolMsg: boolean;
  meeting?: IMeetingDetails;
  isProtocolAvailable: boolean;
  protocol?: IProtocolDto;
  recording?: IRecordingDto;
  pendingTasksCount: number;
  isMeetSummarized: boolean;
  notSummarizedReason?: IEnumInfo<MeetNotSummarizedReason>;
  prevMeetings?: IPreviousMeetInfoDto[];
}

export interface IClosedCommittee extends ICommittee {
  purposeType: IEnumInfo<CommitteePurposeType>;
  isProtocolAvailable: boolean;
  protocol?: IProtocolDto;
  recording?: IRecordingDto;
  isRecentlyClosed: boolean;
  closeDate: Date;
  isMeetSummarized: boolean;
  notSummarizedReason?: IEnumInfo<MeetNotSummarizedReason>;
  stage: IEnumInfo<HearingStageType>;
  stageDate?: Date;
}

export interface INotHeldCommittee extends ICommittee {
  originalDate?: Date;
  notHeldReason: IEnumInfo<MeetNotHeldReason>;
  purposeType?: IEnumInfo<CommitteePurposeType>;
}

export interface IInactiveCommittee extends ICommittee {
  purposeType: IEnumInfo<CommitteePurposeType>;
  closedDate: Date;
  isProtocolAvailable: boolean;
  protocol?: IProtocolDto;
}

export interface IUnscheduledCommittee extends ICommittee {
  pendingTasksCount: number;
}

export interface IMeetingDetails {
  meetingNumber?: number;
  date?: Date;
  location?: string;
  locationCode?: number;
  address?: string;
  zoomLink?: string;
  attendanceType: IEnumInfo<PatientAttendanceStatus>;
  isExternal: boolean;
}

export interface IHearingStage {
  stageType: IEnumInfo<HearingStageType>;
  date?: Date;
  prevMeetingNumber?: number;
  prevMeetNotSummarizedReason?: IEnumInfo<MeetNotSummarizedReason>;
}

export interface ICommitteeDetails {
  meetNumber: number;
  lastUpdated?: Date;
  pgimot: ICommitteePgimaDto[];
  type: IEnumInfo<CommitteeType>;
}

export interface IActiveCommitteeDetails extends ICommitteeDetails {
  purposeType: IEnumInfo<CommitteePurposeType>;
  pendingTasks: IUserTask[];
  meeting: IMeetingDetails;
  attendants: IAttendant[];
  stages: IHearingStage[];
  canDownloadProtocol: boolean;
  protocol?: IProtocolDto;
  recording?: IRecordingDto;
  isMeetSummarized: boolean;
  notSummarizedReason?: IEnumInfo<MeetNotSummarizedReason>;
  currentStage: IEnumInfo<HearingStageType>;
  prevMeetings?: IPreviousMeetInfoDto[];
}

export interface IUnscheduledCommitteeDetails extends ICommitteeDetails {
  pendingTasks: IUserTask[];
}

export interface INotHeldCommitteeDetails extends ICommitteeDetails {
  originalDate: Date;
  notHeldReason: IEnumInfo<MeetNotHeldReason>;
  stages: IHearingStage[];
  currentStage: IEnumInfo<HearingStageType>;
}

export interface IInactiveCommitteeDetails extends ICommitteeDetails {
  purposeType: IEnumInfo<CommitteePurposeType>;
  closedDate: Date;
  protocol?: IProtocolDto;
  recording?: IRecordingDto;
}

export interface IAttendant {
  shemeshSplCode: string;
  speciality: string;
  willAttend: boolean;
}

export interface ICommitteeRecording {
  id: string;
  name: string;
  fileContent: string;
  description?: string;
  date?: Date;
  committeeId?: number;
}

export interface IRecordingDto {
  name: string;
  pgimot?: ICommitteePgimaDto[];
  fileDate?: Date;
  meetNumber?: number;
  documentNumber: string;
}

export interface IProtocolDto {
  name: string;
  fileDate?: Date;
  meetNumber?: number;
  documentNumber: string;
}

export interface IDocumentDto {
  id: number;
  documentNumber: string;
  caseNumber: string;
  fileDate?: Date;
  subjectId: number;
  subjectName: string;
  createDate?: Date;
  intRequestNumber: string;
  documentName: string;
  fileContentBase64: string;
}

export interface ICommitteeTimeline {
  stages: IHearingStage[];
  currentStage: IEnumInfo<HearingStageType>;
  nextStage?: IEnumInfo<HearingStageType>;
  estimatedCompletionDate?: Date;
}

// State content interfaces moved to Interfaces/Umbraco/MedicalCommittees.ts
export type {
  ICommitteeLocation,
  IStateContentResponse,
  IStateContentInterestItem,
  IStateContentSuggestion,
  IStateContentButton,
} from 'Interfaces/Umbraco/MedicalCommittees';

export type Committee =
  | IActiveCommittee
  | IClosedCommittee
  | INotHeldCommittee
  | IInactiveCommittee
  | IUnscheduledCommittee;

export type CommitteeDetails =
  | IActiveCommitteeDetails
  | IUnscheduledCommitteeDetails
  | INotHeldCommitteeDetails
  | IInactiveCommitteeDetails;

export interface ICommitteesResponse {
  committees: Committee[];
  stateNumber: CommitteeUserState;
  hasLawyerRepresentation: boolean;
}
